import { PanelToolbar } from '../../components/panels/PanelToolbar';
import { ProcessingNotice } from '../../components/panels/ProcessingNotice';

const SIDEBAR = [
  'TVD',
  'Block Position',
  'Rate of Penetration (avg)',
  'WOB',
  'RPM',
  'Hookload',
  'SPP',
  'Torque',
  'Total Gas',
  'Mud Flow In',
  'Mud Flow Out',
  'Mud Density In',
];

export function RtTimeDepth() {
  return (
    <div className="splitpane splitpane--thirds">
      <section className="panel" aria-label="RT Timelog">
        <PanelToolbar title="RT Timelog" />
        <ProcessingNotice />
      </section>

      <section className="panel" aria-label="RT Depth Log">
        <PanelToolbar title="RT DEPTH LOG" accent />
        <ProcessingNotice />
      </section>

      <aside className="navalues" aria-label="Current channel values">
        {SIDEBAR.map((label) => (
          <div className="navalue" key={label}>
            <span className="navalue-label">{label}</span>
            <span className="navalue-figure">N/A</span>
          </div>
        ))}
      </aside>
    </div>
  );
}
